import initialStage from 'aurora-images/initialStage.svg';
import initialStageV2 from 'aurora-images/initialStageV2.svg';

const styles = theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    marginBottom: '100px',
  },
  mobileTitlehead: {
    borderBottom: '1px solid #EBEEF3',
    '& > div': {
      padding: '12px 0px',
    },
    '& a': {
      color: '#342D3D',
      padding: '7px 0',
      fontWeight: '500',
      display: 'block',
      textDecoration: 'none',
      '&:hover': {
        textDecoration: 'none',
      },
      '& img': {
        marginRight: '13px',
      },
    },
    '& $grayArea': {
      background: '#F8F8F8',
      color: '#8C9099',
      '& p': {
        fontSize: '12px',
      },
    },
  },
  sectionColumn: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  sectionColumnTitle: {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
  },
  sectionRow: {
    display: 'flex',
    gap: '16px',
  },
  serviceTitle: {
    fontSize: '32px',
  },
  serviceDescription: {
    '& h2': {
      fontSize: '18px',
      fontWeight: '600',
    },
    '& p': {
      fontSize: '16px',
      fontWeight: '500',
    },
  },
  applicationJourney: {
    '& h2': {
      fontSize: '18px',
      fontWeight: '600',
    },
  },
  // steps: {

  //   '&>div': {
  //     minWidth: '160px',
  //     minHeight: '156px',
  //     maxWidth: '160px',
  //     maxHeight: '156px',
  //   },
  //   [theme.breakpoints.down('sm')]: {
  //     display:'flex',
  //     flexDirection:'column',
  //     width:'auto'
  //     },
  // },
  steps: {
    '& > div': {
      minWidth: '160px',
      minHeight: '156px',
      maxWidth: '160px',
      // maxHeight: '156px',
    },

    [theme.breakpoints.down('xs')]: {
      display: 'flex',
      flexDirection: 'column',

      // justifyContent:'center',
      alignItems: 'center',

      '& > div': {
        minWidth: '288px',
        minHeight: 'auto',
        maxWidth: '288px',
        maxHeight: 'none',
      },
    },
  },
  initialStep: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '16px',
    backgroundImage: `url(${initialStage})`,
    [theme.breakpoints.down('xs')]: {
      minWidth: '288px',
      maxWidth: '288px',
      backgroundImage: `url(${initialStageV2})`,
      backgroundPosition: 'center',
      backgroundSize: 'contain',
      //  backgroundSize: 'cover',
    },

    backgroundPosition: 'center',
    backgroundSize: 'cover',
    transform: localStorage.getItem('lang') === 'ar' ? 'scaleX(-1)' : 'scaleX(1)',
    '&>p': {
      maxWidth: '88px',
      fontSize: '14px',
      fontWeight: '500',
      transform: localStorage.getItem('lang') === 'ar' ? 'scaleX(-1)' : 'scaleX(1)',
    },
  },

  middleStep: {
    display: 'flex',
    flexDirection: 'column',
    border: '1px solid #D5D6D7',
    background: 'white',
    gap: '8px',
    padding: '16px',
    '&>p': {
      maxWidth: '88px',
      fontSize: '14px',
      fontWeight: '500',
    },
  },
  finalStep: {
    display: 'flex',
    flexDirection: 'column',
    background: '#CCE7FF',
    gap: '8px',
    padding: '16px',
    '&>p': {
      maxWidth: '88px',
    },
  },
  round: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '28px',
    height: '28px',
    borderRadius: '30px',
    border: `1px solid ${theme.palette.primary.adgmBlack}`,
    color: theme.palette.primary.adgmBlack,
    fontSize: '12px',
  },
  section: {
    '& h2': {
      fontSize: '18px',
      fontWeight: '600',
    },
    '& p': {
      fontSize: '16px',
      fontWeight: '500',
    },
  },
  innerLines: {
    display: 'flex',
    gap: '8px',
  },

  // Footer
  nextbtn: {},
  backButton: {},
  previousButton: {},
  reviewActionsWrapper: {
    minWidth: '100%',
    left: '0px',
    right: 0,
    bottom: 0,
    padding: '16px',
    position: 'fixed',
    background: 'white',
    boxShadow: '0px -1px 8px rgba(0, 0, 0, 0.1)',
    [theme.breakpoints.down('xs')]: {
      bottom: '70px',
    },
  },
  buttonSection: {
    display: 'flex',
    margin: '0 auto',
    justifyContent: 'space-between',
  },
  nextprevBtnholder: {
    display: 'flex',

    '& button': {
      // minWidth: '151px',
      padding: '15px',
      height: '55px',
      fontWeight: '600',
      fontSize: '16px',
      textTransform: 'capitalize',
      //  '&:hover': {
      //    boxShadow: '1px 2px 10px rgba(0, 0, 0, 0.3)',
      //  },
      [theme.breakpoints.down('sm')]: {
        fontSize: '12px',
      },
    },

    '& $nextbtn': {
      background: theme.palette.primary.main,
      color: theme.palette.primary.white,
      fontSize: '16px',
      lineHeight: '24px',
      fontWeight: '500',
      fontStyle: 'normal',
      // marginLeft: 'auto',
      '&>span': {
        gap: '10px',
      },
      '&:hover': {
        backgroundColor: theme.palette.primary.adgmHover,
        color: theme.palette.primary.white,
        border: 'none',
      },
    },
    '& $backButton': {
      color: theme.palette.primary.main,
      fontSize: '16px',
      lineHeight: '24px',
      fontWeight: '500',
      fontStyle: 'normal',

      '&:hover': {
        background: 'none',
      },
      '&>span': {
        gap: '10px',
        justifyContent: 'flex-start',
      },
    },
    '& $previousButton': {
      border: '1px solid #342D3D',
      color: '#342D3D',
      '&:hover': {
        background: 'none',
      },
      '&>span': {
        gap: '8px',
        justifyContent: 'center',
        alignItems: 'center',
      },
    },
  },
  '@media (max-width:767px)': {
    nextprevBtnholder: {
      position: 'fixed',

      bottom: '0',
      left: '0',
      right: '0',
      background: '#fff',
      padding: '16px 10px',
      borderTop: '3px solid #EBEEF3',
      zIndex: '1021',
      '& button': {
        width: '100%',
        margin: '0 5px',
        height: '48px',
      },
      '& $nextbtn': {
        margin: '0 5px',
      },
      [theme.breakpoints.down('sm')]: {
        bottom: '68px',
      },
    },
  },
  '& $nextprevBtnholder': {
    [theme.breakpoints.up('sm')]: {
      boxShadow: '0px -1px 8px rgba(0, 0, 0, 0.1)',
      background: 'white',
      padding: '16px 24px',
      marginTop: '64px',
      position: 'absolute',
      bottom: '0px',
      left: '0px',
      width: '100%',
    },
  },
  rotateArrow: {
    '& img': {
      marginRight: '8px',
      transform: 'rotate(180deg)',
    },
  },
});

export default styles;
